import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      styleOverrides: {
        main: {},
      },
    },
  };
}
